import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi'
import { maxUint256 } from 'viem'
import { W2USDT_ADDRESS, BRIDGE_CONTRACT_ADDRESS, UNI2_CHAIN_ID } from '@/constants/addresses'
import { ERC20_ABI } from '@/constants/abis'

export function useApproveToken() {
  const {
    data: hash,
    writeContract,
    isPending: isWriting,
    error: writeError,
    reset,
  } = useWriteContract()

  const {
    isLoading: isConfirming,
    isSuccess,
    error: confirmError,
  } = useWaitForTransactionReceipt({
    hash,
  })

  const approve = async (amount?: bigint) => {
    const approveAmount = amount ?? maxUint256

    writeContract({
      address: W2USDT_ADDRESS,
      abi: ERC20_ABI,
      functionName: 'approve',
      args: [BRIDGE_CONTRACT_ADDRESS, approveAmount],
      chainId: UNI2_CHAIN_ID,
    })
  }

  return {
    approve,
    hash,
    isWriting,
    isConfirming,
    isSuccess,
    isPending: isWriting || isConfirming,
    error: writeError || confirmError,
    reset,
  }
}
